import React from 'react';
import { TabProps } from './types';

const Tab = ({ children }: React.PropsWithChildren<TabProps>) => {
  return <>{children}</>;
};

export default Tab;
